import script from "./UserDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./UserDropDown.vue?vue&type=style&index=0&id=786dd2ce&class=scoped&lang=css"

const __exports__ = script;

export default __exports__